import React from 'react';
import { TextField, TextareaAutosize } from '@mui/material';
import '../Report/Report.scss';
import { ReportProps } from '../types';

const ReportItem: React.FC<ReportProps> = (props) => {
    return (
        <div className="report-item">
            <div className="points-container">
                <TextField
                    className="points-field"
                    key={`pointsFrom_${props.language}`}
                    defaultValue={props.report.pointsFrom}
                    variant="outlined"
                    type="number"
                    id={`pointsFrom_${props.language}`}
                    label="Points from"
                    name={`pointsFrom_${props.language}`}
                    onChange={(e) => props.updatePoints(props.report.id, e)}
                    error={(props.report.pointsFrom ?? 0) < 0}
                ></TextField>
                <TextField
                    className="points-field"
                    key={`pointsTo_${props.language}`}
                    defaultValue={props.report.pointsTo}
                    variant="outlined"
                    type="number"
                    id={`pointsTo_${props.language}`}
                    label="Points to"
                    name={`pointsTo_${props.language}`}
                    onChange={(e) => props.updatePoints(props.report.id, e)}
                    error={(props.report.pointsTo ?? 0) < 0}
                ></TextField>
            </div>
            <TextareaAutosize
                className="description"
                key={`description_${props.language}`}
                defaultValue={props.report.description?.[props.language]}
                id={`description_${props.language}`}
                placeholder={'Description'}
                name={`description_${props.language}`}
                maxRows={6}
                onChange={(e) => props.updateDescription(props.report.id, e)}
            ></TextareaAutosize>
        </div>
    );
};

export default ReportItem;
